class User {
    constructor() {
        this.isUser = false;
        this.customerId = false;
        this.loginUrl = false;
        this.cookieDomain = false;
        this.customerName = false;
    };

    init(obj) {
        this.customerId = obj.customerId;
        this.customerName = obj.customerName;
        this.loginUrl = obj.loginUrl;
        if(!obj.isGuest) {
            this.isUser = true;
        }

        if (obj.cookieDomain) {
            this.cookieDomain = obj.cookieDomain;
        }
    };
    
    get hasCustomerId() {
        return (this.customerId) ? true : false;
    };
}

export let user = new User();
